module.exports = require("./bg-BG");